
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M12.5 4.5h2.152c.468 0 .848.37.848.828v8.344c0 .457-.38.828-.848.828H2.348a.84.84 0 0 1-.848-.828V5.328c0-.457.38-.828.848-.828H4.5m5.5 6h3m-3-2h3M8.5 12a2.3 2.3 0 0 0-.87-1.08 2.5 2.5 0 0 0-1.36-.42 2.5 2.5 0 0 0-1.372.388A2.3 2.3 0 0 0 4 11.946M7.3 5.5c-.442 0-.8-.336-.8-.75v-1.5c0-.414.358-.75.8-.75h2.4c.442 0 .8.336.8.75v1.5c0 .414-.358.75-.8.75zm.345 3.503a1.48 1.48 0 1 1-2.96 0 1.48 1.48 0 0 1 2.96 0Z"}})])
          )
        }
      }
    